import { render, staticRenderFns } from "./Practical.vue?vue&type=template&id=51ca7395&scoped=true"
import script from "./Practical.vue?vue&type=script&lang=ts"
export * from "./Practical.vue?vue&type=script&lang=ts"
import style0 from "./Practical.vue?vue&type=style&index=0&id=51ca7395&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ca7395",
  null
  
)

export default component.exports